import { useState } from "react";
import AuthServices from "apis/auth/AuthServices";

function useProvideAuth() {

  // *For User
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));

  // *For Login
  const userLogin = (data) => {
    localStorage.setItem('user', JSON.stringify(data))
    setUser(data)
  };

  // *For Logout
  const userLogout = async () => {
    // await AuthServices.logout()
    setUser(null)
    localStorage.clear()
  };

  return {
    user,
    userLogin,
    userLogout
  };
}

export default useProvideAuth;